import React, { useState, useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiBold, FiItalic, FiUnderline, FiList, FiLink, FiImage,
  FiAlignLeft, FiAlignCenter, FiCode, FiYoutube, FiType
} = FiIcons;

const ToolbarBtn = ({ icon, title, onClick, active }) => (
  <button type="button" title={title} onClick={onClick}
    className={`p-2 rounded-lg transition-all text-sm ${active ? 'bg-purple-600 text-white' : 'bg-white/5 text-white/60 hover:bg-white/10 hover:text-white'}`}
  >
    <SafeIcon icon={icon} />
  </button>
);

const ReviewEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);

  const exec = (cmd, val = null) => {
    editorRef.current?.focus();
    document.execCommand(cmd, false, val);
    onChange(editorRef.current?.innerHTML || '');
  };

  const insertLink = () => {
    const url = prompt('Enter URL:');
    if (url) exec('createLink', url);
  };

  const insertVideo = () => {
    const url = prompt('Enter YouTube or video URL:');
    if (!url) return;
    let embedHtml = '';
    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) {
      embedHtml = `<div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:12px;margin:16px 0"><iframe src="https://www.youtube.com/embed/${ytMatch[1]}" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0" allowfullscreen></iframe></div>`;
    } else {
      embedHtml = `<video controls style="width:100%;border-radius:12px;margin:16px 0"><source src="${url}"><a href="${url}" target="_blank">Watch video</a></video>`;
    }
    document.execCommand('insertHTML', false, embedHtml);
    onChange(editorRef.current?.innerHTML || '');
  };

  const insertHeading = (level) => {
    exec('formatBlock', `h${level}`);
  };

  return (
    <div className="border border-[#2a1f42] rounded-xl overflow-hidden bg-[#0a0118]">
      {/* Toolbar */}
      <div className="flex flex-wrap gap-1 p-2 border-b border-[#2a1f42] bg-[#0c0118]">
        <ToolbarBtn icon={FiBold} title="Bold" onClick={() => exec('bold')} />
        <ToolbarBtn icon={FiItalic} title="Italic" onClick={() => exec('italic')} />
        <ToolbarBtn icon={FiUnderline} title="Underline" onClick={() => exec('underline')} />
        <div className="w-px bg-white/10 mx-1" />
        <button type="button" onClick={() => insertHeading(2)} title="Heading 2"
          className="px-2 py-1.5 rounded-lg bg-white/5 text-white/60 hover:bg-white/10 hover:text-white text-xs font-bold transition-all"
        >H2</button>
        <button type="button" onClick={() => insertHeading(3)} title="Heading 3"
          className="px-2 py-1.5 rounded-lg bg-white/5 text-white/60 hover:bg-white/10 hover:text-white text-xs font-bold transition-all"
        >H3</button>
        <div className="w-px bg-white/10 mx-1" />
        <ToolbarBtn icon={FiList} title="Bullet List" onClick={() => exec('insertUnorderedList')} />
        <ToolbarBtn icon={FiAlignLeft} title="Ordered List" onClick={() => exec('insertOrderedList')} />
        <div className="w-px bg-white/10 mx-1" />
        <ToolbarBtn icon={FiLink} title="Insert Link" onClick={insertLink} />
        <ToolbarBtn icon={FiYoutube} title="Embed Video" onClick={insertVideo} />
        <ToolbarBtn icon={FiCode} title="Code" onClick={() => exec('formatBlock', 'pre')} />
        <div className="w-px bg-white/10 mx-1" />
        <ToolbarBtn icon={FiAlignCenter} title="Blockquote" onClick={() => exec('formatBlock', 'blockquote')} />
      </div>
      {/* Editor */}
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(editorRef.current?.innerHTML || '')}
        className="min-h-[320px] p-4 text-white/80 text-sm leading-relaxed focus:outline-none review-body"
        style={{ caretColor: '#a855f7' }}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </div>
  );
};

export default ReviewEditor;